import { FC, ReactNode } from 'react';
import { Button, CircularProgress, Typography } from '@mui/material';
import type { SxProps, Theme } from '@mui/material/styles';

import styles from './CustomButton.module.scss';

type CustomButtonProps = {
  children: string | ReactNode;
  variant?: 'contained' | 'text' | 'outlined';
  disabled?: boolean;
  loading?: boolean;
  btnType?: 'submit' | 'button';
  customClass?: string;
  startIcon?: ReactNode;
  textVariant?: string;
  onClick?: (() => void) | ((event: React.MouseEvent<HTMLButtonElement>) => void);
  sx?: SxProps<Theme>;
};

const CustomButton: FC<CustomButtonProps> = ({
  children,
  variant = 'contained',
  disabled = false,
  loading = false,
  btnType = 'button',
  customClass,
  startIcon,
  textVariant = 'h10Bold',
  onClick,
  sx,
}) => {
  const resolvedStartIcon = loading ? (
    <CircularProgress
      color="inherit"
      size={20}
      thickness={4}
      aria-hidden
    />
  ) : (
    startIcon
  );

  const isIconOnly = resolvedStartIcon && (!children || children === '');

  return (
    <Button
      id={styles.customBtn}
      type={btnType}
      variant={variant}
      aria-busy={loading || undefined}
      className={`${customClass} ${variant === 'contained' ? styles.defaultPrimary : styles.defaultSecondary} ${
        isIconOnly ? styles.iconOnly : ''
      }`}
      disabled={disabled || loading}
      onClick={onClick}
      startIcon={resolvedStartIcon}
      sx={sx}
    >
      {children && <Typography variant={textVariant as any}>{children}</Typography>}
    </Button>
  );
};

export default CustomButton;
